/**
 * Erlaubte Datei-Endungen fuer den Upload (Datei- und Ordner-Upload). Bisher nur als HTML-`accept`-String
 * hinterlegt (kosmetischer Browser-Dialog-Filter, nicht im Code durchgesetzt) - hier zentral definiert,
 * damit `openUploadSelection()` echte Validierung durchfuehren kann.
 */
export const ALLOWED_UPLOAD_EXTENSIONS: ReadonlySet<string> = new Set([
  'pdf', 'ifc', 'xlsx', 'pptx', 'docx',
]);

export function isAllowedUploadExtension(fileName: string): boolean {
  const extension = fileName.split('.').pop()?.toLowerCase() ?? '';
  return ALLOWED_UPLOAD_EXTENSIONS.has(extension);
}
